import React, { useState, useRef, useEffect } from "react"
import "./also-consulted.scss"
import ConsultingService from "../../../shared/services/consulting-service"
import BottomScrollListener from "react-bottom-scroll-listener"
import Loader from "react-loader-spinner"
import ModalDetailComment from "../../molecules/modal-detail-comment/modal-detail-comment"

const AlsoConsulted = props => {
  const {
    slug,
    mobile,
    setModalActive,
    titleDoctor,
    imgConsulting,
    tags,
  } = props

  const [activeTopic, setactiveTopic] = useState("Más recomendados")
  const [currentPage, setcurrentPage] = useState(0)
  const [isLeft, setisLeft] = useState(true)
  const [listComments, setlistComments] = useState(null)
  const [showLoader, setshowLoader] = useState(false)
  const [isLastPage, setisLastPage] = useState(false)
  const [localLikes, setlocalLikes] = useState([])
  const [fakeLikesList, setfakeLikesList] = useState(null)

  const boxButtons = useRef(null)

  useEffect(() => {
    handleLoadComments(activeTopic)

    if (localStorage.getItem("TOKEN_INFO") === null) {
      if (localStorage.getItem("LOCAL_PRODUCT_LIKES") !== null) {
        setlocalLikes(JSON.parse(localStorage.getItem("LOCAL_PRODUCT_LIKES")))
      }
    } else {
      if (localStorage.getItem("LOCAL_PRODUCT_LIKES") !== null) {
        localStorage.removeItem("LOCAL_PRODUCT_LIKES")
      }
    }
  }, [])

  const handleLike = (idProduct, likeState) => {
    var payload = {
      consultationId: idProduct,
      useful: likeState === 1,
    }

    if (localStorage.getItem("TOKEN_INFO") === null) {
      ConsultingService.setLikeAlsoConsulted(payload).then(res => {
        if (res.status === 200) {
          if (likeState === 1) {
            if (fakeLikesList === null) {
              setfakeLikesList([
                {
                  idProduct: idProduct,
                },
              ])
            } else {
              var copyfakeLikesList = fakeLikesList
              var newFakeLikesList = copyfakeLikesList.concat([
                {
                  idProduct: idProduct,
                },
              ])
              setfakeLikesList(newFakeLikesList)
            }
          }
          if (localLikes === null) {
            setlocalLikes([
              {
                idProduct: idProduct,
                likeState: likeState,
              },
            ])
            localStorage.setItem(
              "LOCAL_PRODUCT_LIKES",
              JSON.stringify([
                {
                  idProduct: idProduct,
                  likeState: likeState,
                },
              ])
            )
          } else {
            var copyLocalLikes = localLikes.push({
              idProduct: idProduct,
              likeState: likeState,
            })
            setlocalLikes([copyLocalLikes])
            localStorage.setItem(
              "LOCAL_PRODUCT_LIKES",
              JSON.stringify(localLikes)
            )
          }
        }
      })
    } else {
      var tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken
      var config = {
        headers: {
          Authorization: tokenId,
        },
      }

      ConsultingService.setLikeAlsoConsultedAuth(payload, config).then(res => {
        if (res.status === 200) {
          if (likeState === 1) {
            if (fakeLikesList === null) {
              setfakeLikesList([
                {
                  idProduct: idProduct,
                },
              ])
            } else {
              var copyfakeLikesList = fakeLikesList
              var newFakeLikesList = copyfakeLikesList.concat([
                {
                  idProduct: idProduct,
                },
              ])

              setfakeLikesList(newFakeLikesList)
            }
          }
          if (localLikes === null) {
            setlocalLikes([
              {
                idProduct: idProduct,
                likeState: likeState,
              },
            ])

            localStorage.setItem(
              "LOCAL_PRODUCT_LIKES",
              JSON.stringify([
                {
                  idProduct: idProduct,
                  likeState: likeState,
                },
              ])
            )
          } else {
            var copyLocalLikes = localLikes
            var newLocalLikes = copyLocalLikes.concat([
              {
                idProduct: idProduct,
                likeState: likeState,
              },
            ])
            setlocalLikes(newLocalLikes)
            localStorage.setItem(
              "LOCAL_PRODUCT_LIKES",
              JSON.stringify(newLocalLikes)
            )
          }
        }
      })
    }
  }

  const handleLoadComments = nameTopic => {
    setisLastPage(false)
    setactiveTopic(nameTopic)
    setcurrentPage(0)

    if (localStorage.getItem("TOKEN_INFO") === null) {
      ConsultingService.getListComments(
        slug.toUpperCase(),
        nameTopic,
        6,
        currentPage
      )
        .then(res => {
          if (res.metadata.currentPage + 1 >= res.metadata.limit) {
            setisLastPage(true)
          }
          setlistComments(res.data)
        })
        .catch(e => console.log(e))
    } else {
      var tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken

      var config = {
        headers: {
          Authorization: tokenId,
        },
      }

      ConsultingService.getListCommentsAuth(
        slug.toUpperCase(),
        nameTopic,
        6,
        currentPage,
        config
      )
        .then(res => {
          if (res.metadata.currentPage + 1 >= res.metadata.limit) {
            setisLastPage(true)
          }
          setlistComments(res.data)

          var targetLocalLikes = []
          for (let i = 0; i < res.data.length; i++) {
            targetLocalLikes = targetLocalLikes.concat([
              {
                idProduct: res.data[i].consultationId,
                likeState: res.data[i].useful,
              },
            ])
          }
          setlocalLikes(targetLocalLikes)
        })
        .catch(e => console.log(e))
    }
  }

  const handleLoadMoreComments = nameTopic => {
    setshowLoader(true)

    var copyCurrentPage = currentPage
    var copyListComments = listComments

    setcurrentPage(copyCurrentPage + 1)

    if (localStorage.getItem("TOKEN_INFO") === null) {
      ConsultingService.getListComments(
        slug.toUpperCase(),
        nameTopic,
        6,
        copyCurrentPage + 1
      )
        .then(res => {
          // copyListComments = copyListComments.concat(res.data)
          if (res.metadata.currentPage + 1 >= res.metadata.limit) {
            setisLastPage(true)
          }
          Array.prototype.push.apply(copyListComments, res.data)
          setlistComments(copyListComments)
          setshowLoader(false)
        })
        .catch(e => console.log(e))
    } else {
      var tokenId = JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken
      var config = {
        headers: {
          Authorization: tokenId,
        },
      }
      ConsultingService.getListCommentsAuth(
        slug.toUpperCase(),
        nameTopic,
        6,
        copyCurrentPage + 1,
        config
      )
        .then(res => {
          // copyListComments = copyListComments.concat(res.data)
          if (res.metadata.currentPage + 1 >= res.metadata.limit) {
            setisLastPage(true)
          }
          Array.prototype.push.apply(copyListComments, res.data)
          setlistComments(copyListComments)
          setshowLoader(false)

          var targetLocalLikes = localLikes
          for (let i = 0; i < res.data.length; i++) {
            targetLocalLikes = targetLocalLikes.concat([
              {
                idProduct: res.data[i].consultationId,
                likeState: res.data[i].useful,
              },
            ])
          }
          setlocalLikes(targetLocalLikes)
        })
        .catch(e => console.log(e))
    }
  }

  const handleShowModal = index => {
    // Verify if have more comments to show
    if (index === listComments.length - 1) {
      handleLoadMoreComments(activeTopic)
    }

    var body = document.getElementsByTagName("body")[0]
    var html = document.getElementsByTagName("html")[0]
    body.classList.add("overflow-body-hidden")
    html.classList.add("overflow-body-hidden")

    setModalActive(
      <ModalDetailComment
        titleDoctor={titleDoctor}
        setModalActive={setModalActive}
        question={listComments[index].question}
        answer={listComments[index].answer}
        consultationId={listComments[index].consultationId}
        currentActiveModal={index}
        handleShowModal={handleShowModal}
        mobile={mobile}
        imgConsulting={imgConsulting}
        slug={slug}
        localLikes={localLikes}
        handleLike={handleLike}
        likeState={
          localLikes !== null
            ? localLikes.filter(
                local => local.idProduct === listComments[index].consultationId
              ).length !== 0
              ? localLikes.filter(
                  local =>
                    local.idProduct === listComments[index].consultationId
                )[
                  localLikes.filter(
                    local =>
                      local.idProduct === listComments[index].consultationId
                  ).length - 1
                ].likeState === 1
                ? 1
                : 2
              : 0
            : listComments[index].useful === 1
            ? 1
            : listComments[index].useful === 2
            ? 0
            : 2
        }
      />
    )
  }

  const handleTopicsScroll = () => {
    if (isLeft) {
      setisLeft(false)
      boxButtons.current.scrollTo(500, 0)
    } else {
      setisLeft(true)
      boxButtons.current.scrollTo(0, 0)
    }
  }

  const singleLabelByCountry =
    process.env.LOCALE === "es-PY"
      ? "Encontrá respuestas a tus dudas eligiendo el tema que más llame tu atención, así podrás saber qué han preguntado otras chicas y si encontrás respuestas a tus dudas."
      : process.env.LOCALE === "es-AR"
      ? "Elegí el tema que más llame tu atención, así podrás saber qué han preguntado otras chicas y quizás encontrar la respuesta a tus inquietudes!"
      : "Encuentra respuestas a tus dudas eligiendo el tema que más llame tu atención, así podrás saber qué han preguntado otras chicas y si encuentras respuestas a tus dudas."

  return (
    <section className="f-also-consulted-section">
      {!isLastPage && mobile && (
        <BottomScrollListener
          onBottom={() => handleLoadMoreComments(activeTopic)}
        />
      )}
      <div className="f-also-consulted-container">
        <h2 className="f-also-consulted-title">
          <span className="purple">Otras chicas </span>también consultaron
        </h2>
        <p className="f-also-consulted-description">{singleLabelByCountry}</p>
        <div className="f-buttons-container">
          <div
            className={
              "f-buttons-category-container " +
              (isLeft ? "is-left" : "is-right")
            }
            ref={boxButtons}
          >
            <div
              onClick={() => handleLoadComments("Más recomendados")}
              className={
                "f-fake-button " +
                (activeTopic === "Más recomendados" ? "f-active" : "")
              }
            >
              Más recomendado
              <span className="f-icon icon-like" />
            </div>

            {tags.map((tag, index) => {
              return (
                <div
                  key={index}
                  onClick={() => handleLoadComments(tag.nombreEtiqueta)}
                  className={
                    "f-fake-button " +
                    (activeTopic === tag.nombreEtiqueta ? "f-active" : "")
                  }
                >
                  {tag.nombreEtiqueta}
                </div>
              )
            })}
            <div className="f-spacer-scroll" />
          </div>
          <div className="f-scroll-button" onClick={() => handleTopicsScroll()}>
            <span className={"f-icon icon-right " + (!isLeft ? "left" : "")} />
          </div>
        </div>
        <div className="f-cards-comments-container">
          {listComments !== null &&
            listComments.map((comment, index) => {
              return (
                <div
                  className="f-card-comment"
                  key={index}
                  onClick={() => {
                    handleShowModal(index)
                  }}
                >
                  <div className="f-header-card-comment">
                    <label className="f-card-category">
                      {comment.consultationTopic}
                    </label>
                    <div className="f-likes-container">
                      {fakeLikesList !== null
                        ? fakeLikesList.filter(
                            fake => fake.idProduct === comment.consultationId
                          ).length !== 0
                          ? comment.recommendations + 1
                          : comment.recommendations
                        : comment.recommendations}
                      {typeof window !== "undefined" ? (
                        localLikes !== null ? (
                          localLikes.filter(
                            local => local.idProduct === comment.consultationId
                          ).length === 0 ? (
                            <span
                              className="f-icon icon-like"
                              onClick={e => {
                                e.stopPropagation()
                                handleLike(comment.consultationId, 1)
                              }}
                            />
                          ) : localLikes.filter(
                              local =>
                                local.idProduct === comment.consultationId
                            )[
                              localLikes.filter(
                                local =>
                                  local.idProduct === comment.consultationId
                              ).length - 1
                            ].likeState === 1 ? (
                            <span className="f-icon icon2-like_hover" />
                          ) : (
                            <span
                              className="f-icon icon-like"
                              onClick={e => {
                                e.stopPropagation()
                                handleLike(comment.consultationId, 1)
                              }}
                            />
                          )
                        ) : comment.useful === 1 ? (
                          <span className="f-icon icon2-like_hover" />
                        ) : (
                          <span
                            className="f-icon icon-like"
                            onClick={e => {
                              e.stopPropagation()
                              handleLike(comment.consultationId, 1)
                            }}
                          />
                        )
                      ) : (
                        <span
                          className="f-icon icon-like"
                          onClick={e => {
                            e.stopPropagation()
                            handleLike(comment.consultationId, 1)
                          }}
                        />
                      )}
                      {/* {localLikes !== null ?
                                                localLikes.filter(local => local.idProduct === comment.consultationId).length === 0 ?
                                                    <span className="f-icon icon-like" onClick={e => { e.stopPropagation(); handleLike(comment.consultationId, 1) }} />
                                                    :
                                                    <span className="f-icon icon2-like_hover" />
                                                :
                                                <span className="f-icon icon-like" onClick={e => { e.stopPropagation(); handleLike(comment.consultationId, 1) }} />
                                            } */}
                    </div>
                    {/* <div className="f-sign-container">{transformTopicToIcon(comment.consultationTopic)}</div> */}
                  </div>
                  <div className="f-body-card-comment">
                    <span className="f-init-sign">"</span>
                    <p className="f-p-comment">{comment.question}</p>
                    <span className="f-last-sign">"</span>
                  </div>
                </div>
              )
            })}
          {listComments !== null && listComments.length === 0 && (
            <label>Aún no hay consultas sobre este tema</label>
          )}
          {!isLastPage && (
            <div className="f-load-more-container">
              {showLoader ? (
                <Loader
                  type="TailSpin"
                  color="#FF409B"
                  height={50}
                  width={50}
                />
              ) : (
                !mobile && (
                  <label
                    className="f-load-more"
                    onClick={() => handleLoadMoreComments(activeTopic)}
                  >
                    Cargar más
                  </label>
                )
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default AlsoConsulted
